import React from 'react';

const TimelineVisual = ({ revealMeta = {} }) => {
  const timelineState = revealMeta.timelineState || {};
  const items = timelineState.visibleItems?.length ? timelineState.visibleItems : [
    { label: 'Begin', dateLabel: 'Start', important: true },
    { label: 'Now', dateLabel: 'Now', important: true },
  ];
  const span = Math.max(1, items.length - 1);

  return (
    <span
      className={`lumirae-layer-visual lumirae-layer-visual-timeline${timelineState.hasItems ? ' has-items' : ' is-empty'}`}
      data-node-count={timelineState.count || items.length}
      aria-hidden="true"
    >
      <span className="line" />
      <span className="ribbon-glow" />
      {items.map((item, index) => {
        const eventY = 1.22 + (index / span) * 7.25;
        return (
          <span
            key={`${item.label}_${index}`}
            className={`event${item.important ? ' is-important' : ''}${index % 2 ? ' is-left' : ' is-right'}`}
            style={{
              '--event-y': `${eventY}rem`,
              '--event-delay': `${160 + index * 95}ms`,
            }}
          >
            <i />
            <b>
              <small>{item.dateLabel}</small>
              <em>{item.label}</em>
            </b>
          </span>
        );
      })}
    </span>
  );
};

export default TimelineVisual;
